@if (contentItem.fields['html'] && !isGlobalInjection) {
  <div
    phxInterceptLinks
    [innerHTML]="contentItem.fields['html'] | phxTrustUnsafe: 'html'"
  ></div>
}
